import {createSlice} from '@reduxjs/toolkit';
import _ from 'lodash'
import cookie from 'react-cookies';
import CommonActions from '../actions/CommonActions';
import { BetTypeGroup, PrefsMap } from '../common/Foundation';
import CommonUtil from '../common/CommonUtil';
/**
 * Build State for Setting Data, Account Data
 * Author: Oliver.Nguyen
 */
const defaultRequiredFormData = {
    isOpen: false,
    isSessionExpired: false,
    errorMessage: '',
}

const loadDefaultMarketUserPref = () => {
  const __prefs = _.isEmpty(cookie.load('__prefs')) ? '' : CommonUtil.decodeBase64(cookie.load('__prefs'));
  const __prefsJSON = _.isEmpty(__prefs) ? {} : CommonUtil.convertStringToJSON(__prefs);
  if (!_.isEmpty(__prefsJSON)) {
    return __prefsJSON[PrefsMap.market] === 0 ? BetTypeGroup.HDP_OU : (__prefsJSON[PrefsMap.market] === 1 ? BetTypeGroup.ML_1X2 : BetTypeGroup.TEAM_TOTAL);
  }
  return BetTypeGroup.HDP_OU;
}

const defaultUserData = {
    token: "",
    loginId: "",
    freshId: "",
    email: "",
    fullName: "",
    mode: "",
    type: "",
    betCredit: "",
    outstanding:"",
    currency: "",
    currencyUnit: 1,
    currentTierId: 1,
    message: "",
    isRefresh: false,
    locale: cookie.load('lang') || 'en_US',
    skin: cookie.load('skin') || 'pa',
    openMessage: false,
    defaultView: 'COMPACT',
    country: "",
    enableMaintenance: false,
    isLogoutAutomation: false,
    displayMode: localStorage.getItem('themeMode') || 'LIGHT',
    esportsLogoVersion: '',
    showBalance: true,  
    betTypeGroupPref: loadDefaultMarketUserPref(),
    maxBetPreferenceSettingBase: false,
    productStatus: {},
    sumAnnouncement: -1,
    supportLeftMenuWS: false, // includes key sports-websocket.enable && isAuth && (isB2BAccount || balance > 0) && inNotBlockWager && enable left menu WS
    supportOddsPageWS: false, // includes key sports-websocket.enable && isAuth && (isB2BAccount || balance > 0) && inNotBlockWager && enable odds page WS
    usingNewLiveScoreWS: false, // includes key sports-websocket.enable and sports-websocket-livescore.enable
    creditWithdrawalEnabled: false,
    supportSpecialWS: false
}

export const AccountsSlice = createSlice({
    name: 'AccountsSlice',
    initialState: {
        user: defaultUserData,
        options: _.isEmpty(localStorage.getItem('perfs')) ? {} : atob(localStorage.getItem('perfs')),
        requiredFormData: defaultRequiredFormData,
        locale: '',
        // status: {},
        isLoginPopupOpening: false,
        isLoginInvalidUserNamePassword: false,
        isNGC: false,
        casinoFavourites: {},
        sumAnnouncementUnread: '',
        totalMessage: -1,
        isOpenAuthenticatorMobileModal: false,
        isOpenRequireLoginModalByMultiple: false,
    },
    reducers: {
        updateUser: (state, {payload}) => {
            _.forEach(payload, (value, key) => {
                state.user[key] = value;
            });
        },
        updateOptions: (state, {payload}) => {
            state.options = payload
        },
        updateCasinoFavourites: (state, {payload}) => {
            state.casinoFavourites = payload
        },
        
        changeLocale: (state, {payload}) => {
            state.locale = payload
        },
        resetUser: (state) => {
            state.user = defaultUserData
        },
        setRequiredFormData: (state, {payload}) => {
            _.forEach(payload, (value, key) => {
                state.requiredFormData[key] = value;
            });
        },
        updateRequiredFormData: (state, {payload}) => {
            const {key, value} = payload;
            const tmp = state.requiredFormData;
            tmp[key] = value;
            state.requiredFormData = tmp;
        },
        resetRequiredFormData: (state) => {
            state.requiredFormData = defaultRequiredFormData;
        },
        updateEsportsLogoVersion: (state, {payload}) => {
            state.esportsLogoVersion = payload
        },
        updateLoginPopupOpening: (state, {payload}) => {
            state.isLoginPopupOpening = payload
            CommonActions.inactiveScroll(payload);
        },
        updateLoginInvalidUserNamePassword: (state, {payload}) => {
            state.isLoginInvalidUserNamePassword = payload
        },
        updateNGC: (state, {payload}) =>{
            state.isNGC = payload  
        },
        updateSumAnnouncementUnread: (state, {payload}) => {
            state.sumAnnouncementUnread = payload
        },
        updateTotalMessage: (state, { payload }) => {
            state.totalMessage = payload
        },
        updateAuthenMobilePopup: (state, { payload }) => {
            state.isOpenAuthenticatorMobileModal = payload;
            CommonActions.inactiveScroll(payload);
        },
        updateIsOpenRequireLoginModalByMultiple: (state, { payload }) => {
            state.isOpenRequireLoginModalByMultiple = payload
        },
    },
});

export const isSupportLS = state => {
  const {sportSuppLS} =  state.AccountsSlice.user;
  return sportSuppLS > -1;
}

export const isApplyMaxBetPreferenceSettingBase = state => {
    const {options} = state.SportsSlice;
    const {user} = state.AccountsSlice;
    return user.auth && options.betTypeGroup != BetTypeGroup.TEASERS && 
    options.betTypeGroup != BetTypeGroup.MIX_PARLAY && user.maxBetPreferenceSettingBase;
}

export const {
    updateLoginPopupOpening,
    updateUser,
    updateAuthenMobilePopup
} = AccountsSlice.actions;


export default AccountsSlice.reducer;


// WEBPACK FOOTER //
// ./src/app/slices/AccountsSlice.js